import { render, staticRenderFns } from "./eDSLicence.vue?vue&type=template&id=6c754640"
import script from "./eDSLicence.vue?vue&type=script&lang=js"
export * from "./eDSLicence.vue?vue&type=script&lang=js"
import style0 from "./eDSLicence.vue?vue&type=style&index=0&id=6c754640&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports